import appConfig from "@config/app";
import { ASK_SW_BUILD_HASH, mtLogger } from "shared-core";

const makePageControllerPromise = (): Promise<ServiceWorker> =>
  new Promise(resolve => {
    if (navigator.serviceWorker.controller) {
      resolve(navigator.serviceWorker.controller);
    }
    navigator.serviceWorker.addEventListener("controllerchange", _ => {
      if (navigator.serviceWorker.controller) {
        resolve(navigator.serviceWorker.controller);
      }
    });
  });

const followSWBuildHash = (): void => {
  makePageControllerPromise()
    .then((controller: ServiceWorker): Promise<string> => {
      const msgChannel = new MessageChannel();
      const rv = new Promise<string>(r => {
        msgChannel.port1.onmessage = (e): void => r(e.data);
      });
      controller.postMessage({ type: ASK_SW_BUILD_HASH }, [msgChannel.port2]);
      return rv;
    })
    .then((swBuildHash: string) => {
      mtLogger.debug(`ServiceWorker controlling page is ${swBuildHash}`);
      if (swBuildHash) {
        appConfig["SW_BUILD_HASH"] = swBuildHash;
      }
    });
};

// Check if service worker are supported
export const useFollowServiceWorker = (): void => {
  // Contrived mechanism to detect and update which service worker is
  // controlling the page. It can change during an update (because we use
  // `skipWaiting`).
  followSWBuildHash();
  navigator.serviceWorker &&
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      mtLogger.debug(`ServiceWorker controller is changing`);
      followSWBuildHash();
    });
};
